<template>
  <funding-base
    :state="state"
  >
    <dashboard-section
      v-for="group in groupedApplications"
      :key="group.title"
    >
      <template #title>
        <h2 class="text-xl mb-2 pr-6 mr-6 border-r">
          {{ group.title }}
        </h2>
        <p class="pb-1">
          {{ group.applications.length }} Applications
        </p>
      </template>
      <ul class="list-reset mt-4">
        <li
          v-for="application in group.applications"
          :key="application.uuid"
        >
          <article
            class="px-6 py-4 flex flex-col bg-white mb-4 shadow-lg"
          >
            <div class="flex flex-1 items-start border-b mb-4 pb-4">
              <div class="flex-1">
                <app-badge
                  :type="group.status"
                  :icon="group.icon"
                >
                  {{ group.badge }}
                </app-badge>
                <h2 class="text-xl mb-2 leading-tight">
                  <template v-if="application.type === 'eoi'">
                    {{ application.title }}
                  </template>
                  <template v-else>
                    [{{ application.ref }}] {{ application.title }}
                  </template>
                </h2>
              </div>
              <div>
                <!-- <template v-if="!application.invited_at && !application.rejected_at">
                  <button @click="approve(application.uuid)">
                    Approve
                  </button>
                  <card-actions>
                    <template #icon>
                      Reject
                    </template>
                    <ul class="list-reset text-sm text-center bg-negative-100">
                      <li
                        v-for="(label, key) in rejectKeys"
                        :key="key"
                      >
                        <button
                          type="button"
                          class="w-full p-2 block"
                          @click="reject(application.uuid, key)"
                        >
                          {{ label }}
                        </button>
                      </li>
                    </ul>
                  </card-actions>
                </template> -->
              </div>
            </div>
            <div class="flex">
              <p class="mr-2 text-sm text-grey-700 flex items-baseline">
                <icon
                  icon="office"
                  class="w-4 h-4 icons-grey mr-2"
                />
                {{ application.user.company.name | sentencecase }}
              </p>
              <p class="mr-2 text-sm text-grey-700 flex items-baseline">
                <icon
                  icon="user"
                  class="w-4 h-4 icons-grey mr-2"
                />
                {{ application.user.name }}
              </p>
            </div>
            <div
              v-if="
                !application.submitted_at &&
                  application.application_progress_percentage
              "
              class="relative -mx-6 -mb-4 h-8 mt-2 overflow-hidden"
            >
              <div
                class="bg-neutral-100 border-neutral-400 absolute h-full pin-t overflow-hidden border-t z-0 text-neutral-600 text-xs flex items-center w-full whitespace-no-wrap"
              >
                <p class="px-6">
                  Progress:
                  <b>{{ application.application_progress_percentage }}%</b>
                </p>
              </div>
              <div
                class="bg-neutral-200 border-neutral-500 absolute h-full pin-t overflow-hidden border-t z-0 text-neutral-800 text-xs flex items-center whitespace-no-wrap"
                :style="
                  `width: ${application.application_progress_percentage}%`
                "
                aria-hidden="hidden"
              >
                <p class="px-6">
                  Progress:
                  <b>{{ application.application_progress_percentage }}%</b>
                </p>
              </div>
            </div>
          </article>
        </li>
      </ul>
    </dashboard-section>
  </funding-base>
</template>

<script>
import { isBefore, parseISO, compareDesc } from "date-fns";
export default {
  name: "FundingApplicationsIndex",
  computed: {
    competition() {
      return this.state.competition;
    },
    filteredCompetitions() {
      return this.state.competition.filter(
        competition => competition.uuid === this.initialCompetition
      );
    },
    applications() {
      if (!this.state.competition) return [];
      return this.competition.applications.map(application => {
        application.type = this.state.competition.type.name;
        return application;
      });
    },
    invitedApplications() {
      return this.applications.filter(application => {
        if (!application.rejected_at && application.invited_at)
          return application;
      });
    },
    rejectedApplications() {
      return this.applications.filter(application => {
        if (application.rejected_at) return application;
      });
    },
    submittedApplications() {
      return this.applications.filter(application => {
        if (
          application.submitted_at &&
          !application.rejected_at &&
          !application.invited_at
        )
          return application;
      });
    },
    draftApplications() {
      return this.applications.filter(application => {
        if (!application.submitted_at && application.application)
          return application;
      });
    },
    notStartedApplications() {
      return this.applications.filter(application => {
        if (!application.application) return application;
      });
    },
    groupedApplications() {
      const applicationGroups = [];
      if (this.invitedApplications.length) {
        applicationGroups.push({
          title: "Invited",
          status: "positive",
          icon: "check",
          badge: "Invited",
          applications: this.invitedApplications
        });
      }
      if (this.rejectedApplications.length) {
        applicationGroups.push({
          title: "Rejected",
          status: "negative",
          icon: "close-circle",
          badge: "Rejected",
          applications: this.rejectedApplications
        });
      }
      if (this.submittedApplications.length) {
        applicationGroups.push({
          title: "Submitted",
          status: "positive",
          icon: "check",
          badge: "Submitted",
          applications: this.submittedApplications
        });
      }
      if (this.draftApplications.length) {
        applicationGroups.push({
          title: this.applicationOpen
            ? "Draft"
            : "Expired",
          status: this.applicationOpen ? "neutral" : "grey",
          icon: "time",
          badge: "Draft",
          applications: this.draftApplications
        });
      }
      if (this.notStartedApplications.length) {
        applicationGroups.push({
          title: "Application Not Started",
          status: "grey",
          icon: "close-circle",
          badge: "Not Started",
          applications: this.notStartedApplications
        });
      }
      return applicationGroups;
    },
    applicationOpen() {
      const latestDates = this.state.competitions?.map(comp => parseISO(comp.application_end_date))
        .sort(compareDesc);
      if(!latestDates) return false
      return isBefore(new Date(), latestDates[0]);
    }
  },
  created() {
    this.initialCompetition = this.getQueryParameterByName("competition");
  }
};
</script>
